import { webPlatformAdapterBuilder } from "@sia/style-guide";
import KeycloakIDPAdapter from "../IDPAdapter/KeycloakIDPAdapter";

const apiUrl = process.env.REACT_APP_WEB_PLATFORM_API_URL;

const webPlatformAdapter = webPlatformAdapterBuilder(KeycloakIDPAdapter, apiUrl);
export default webPlatformAdapter;
